import { useRef } from 'react'
import { motion, useInView, useReducedMotion } from 'framer-motion'

export default function HandHolding() {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })
  const shouldReduceMotion = useReducedMotion()

  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 643 202">
      <motion.g
        initial={{ rotate: '7deg', translateY: '25px' }}
        style={{
          rotate: !isInView && !shouldReduceMotion ? '7deg' : '0deg',
          translateY: !isInView && !shouldReduceMotion ? '25px' : '0px',
          transition: 'transform 0.5s ease-in-out 0.2s',
          transformOrigin: 'top right',
        }}
      >
        <path
          fill="#175DDC"
          d="M-9.10559 201.876S252.957 132.145 275.181 127.594c22.223-4.551 61.245.525 73.321 2.273 12.076 1.748 46.725 2.975 56.872 2.45 10.147-.526 26.774-9.274 37.971-12.602 11.198-3.328 23.098-6.823 28.699-7.525 5.601-.702 35.522-5.95 51.972-10.501 16.45-4.5503 39.901-16.6218 51.624-19.95 11.722-3.3281 27.824-10.849 27.824-10.849 2.626 0 17.673-4.5507 17.673-4.5507 5.076-.5252 16.975-5.2478 19.773-6.8236 2.799-1.5758 1.051-3.1515 1.051-3.1515-.525-13.6473-9.45-18.3746-26.072-18.3746S566.19 52.9524 566.19 52.9524c-15.749-1.5758-42.788 7.8741-42.788 7.8741-6.298-1.0505-26.248 0-26.248 0s-.786-18.1096-15.66-21.4378c-14.875-3.3281-38.149-5.4245-49.174-4.8992-11.026.5252-30.976 2.9749-33.426 2.7982-2.45-.1766-11.026-.5252-19.774-4.374-8.748-3.8488-48.639-27.1133-86.439-22.386-37.799 4.7273-48.3 19.2484-60.725 28.3497C219.532 47.9787-4.21704 96.6042-4.21704 96.6042"
          opacity=".2"
        />
        <path
          fill="#FFBF00"
          d="M-14.696 193.962s266.259-65.536 288.482-70.086c22.223-4.551 61.246.525 73.322 2.272 12.076 1.748 46.724 2.975 56.871 2.45 10.147-.525 26.774-9.273 37.972-12.601 11.198-3.328 23.097-6.824 28.698-7.526 5.601-.702 35.522-5.95 51.972-10.5003 16.451-4.5506 39.901-16.6221 51.624-19.9503 11.723-3.3281 27.824-10.849 27.824-10.849 2.627 0 17.673-4.5507 17.673-4.5507 5.076-.5252 16.976-5.2479 19.774-6.8236 2.798-1.5758 1.05-3.1516 1.05-3.1516-.525-13.6472-9.45-18.3745-26.072-18.3745s-49.699 14.9627-49.699 14.9627c-15.748-1.5757-42.787 7.8742-42.787 7.8742-6.299-1.0505-26.249 0-26.249 0s-.785-18.1096-15.66-21.4378c-14.874-3.3282-38.148-5.4245-49.174-4.8993-11.025.5253-30.976 2.9749-33.425 2.7983-2.45-.1766-11.026-.5253-19.774-4.374-8.748-3.8488-48.64-27.11333-86.439-22.38605-37.8 4.72725-48.3 19.24845-60.725 28.34975-12.425 9.1013-273.5621 47.5601-273.5621 47.5601"
        />
        <path
          stroke="#020F66"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M132.065 151.557s112.988-27.309 135.211-31.86c22.223-4.55 61.246.526 73.322 2.273 12.076 1.748 46.724 2.975 56.871 2.45 10.147-.525 26.774-9.273 37.972-12.601 11.198-3.329 23.097-6.824 28.698-7.526 5.601-.702 35.522-5.9498 51.972-10.5004 16.451-4.5507 39.901-16.6222 51.624-19.9504 11.723-3.3281 27.824-10.849 27.824-10.849 2.627 0 17.673-4.5506 17.673-4.5506 5.076-.5253 16.976-5.2479 19.774-6.8237 2.798-1.5758 1.05-3.1515 1.05-3.1515-.525-13.6473-9.45-18.3746-26.072-18.3746s-49.699 14.9628-49.699 14.9628c-15.748-1.5758-42.787 7.8741-42.787 7.8741-6.299-1.0505-26.249 0-26.249 0s-.785-18.1096-15.66-21.4378c-14.874-3.3281-38.148-5.4245-49.174-4.8992-11.025.5252-30.976 2.9749-33.425 2.7982-2.45-.1766-11.026-.5252-19.774-4.374-8.748-3.8487-48.644-27.11329-86.444-22.38601-37.799 4.72728-48.3 19.24841-60.725 28.34971-12.425 9.1013-205.198 37.761-205.198 37.761"
        />
        <path
          stroke="#020F66"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M308.571 69.6499s18.724 7.0003 41.472 5.0759c22.749-1.9244 17.849-2.101 29.047-.7019s47.947 5.4245 67.372 1.7478c19.425-3.6768 40.947-3.8488 42.787-22.8369"
        />
        <path
          stroke="#020F66"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M474.114 34.3037s-24.324-2.273-24.501 6.6517c-.176 8.9246-3.5 22.4185 4.026 24.157 7.525 1.7384 28.001 2.0917 30.976-4.9086M404.121 37.4512s-9.975 13.4753-1.748 33.7742M414.97 34.0439s-7.698 10.2355-7.001 20.2943M429.844 54.3383s.177 14.0889-3.323 17.761M515.503 52.9393s-1.139 6.8236.785 10.2819M558.29 45.0645s4.55 7.0885 4.722 9.2732M581.061 36.1212s19.751-3.7791 28.852 0c9.101 3.779 13.838 7.6278 13.647 13.5775 0 0 3.677 2.273 1.4 3.2352-2.278.9622-9.632 5.0108-16.293 6.8562"
        />
        <path
          stroke="#020F66"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
          d="M620.409 49.7037s-17.501 3.5001-24.849 13.2987"
        />
      </motion.g>
    </svg>
  )
}
